import { render, staticRenderFns } from "./BigRadioButton.vue?vue&type=template&id=089e97e7&"
import script from "./BigRadioButton.vue?vue&type=script&lang=js&"
export * from "./BigRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports